import React from 'react';

interface BouncingDotsProps {
  color: string; // Hex color code (e.g., "#a855f7")
  size?: 'sm' | 'md' | 'lg';
}

/**
 * Animated bouncing dots indicator for active processors (SWRM-164).
 *
 * Shows three dots that bounce in sequence to indicate a processor is currently running.
 */
export const BouncingDots: React.FC<BouncingDotsProps> = ({ color, size = 'md' }) => {
  const sizeMap = {
    sm: 6,
    md: 8,
    lg: 10,
  };

  const dotSize = sizeMap[size];
  const spacing = size === 'sm' ? 4 : size === 'md' ? 6 : 8;

  return (
    <div className="flex items-center gap-1" style={{ gap: `${spacing}px` }}>
      <style>{`
        @keyframes bounce-dot {
          0%, 80%, 100% {
            transform: translateY(0);
            opacity: 1;
          }
          40% {
            transform: translateY(-10px);
            opacity: 0.7;
          }
        }

        .bouncing-dot {
          animation: bounce-dot 1.4s infinite;
        }

        .bouncing-dot:nth-child(1) {
          animation-delay: 0s;
        }

        .bouncing-dot:nth-child(2) {
          animation-delay: 0.2s;
        }

        .bouncing-dot:nth-child(3) {
          animation-delay: 0.4s;
        }
      `}</style>
      <div
        className="bouncing-dot rounded-full"
        style={{
          width: `${dotSize}px`,
          height: `${dotSize}px`,
          backgroundColor: color,
        }}
      />
      <div
        className="bouncing-dot rounded-full"
        style={{
          width: `${dotSize}px`,
          height: `${dotSize}px`,
          backgroundColor: color,
        }}
      />
      <div
        className="bouncing-dot rounded-full"
        style={{
          width: `${dotSize}px`,
          height: `${dotSize}px`,
          backgroundColor: color,
        }}
      />
    </div>
  );
};

